import {
  REPORT_STATE_POST,
  REPORT_LIST_POST,
  REPORT_DETAIL_POST,
  USER_LIST_POST,
  SYS_CONFIGS_POST
} from "config/url";

//注意不要用export defalt, 不同文件中的list暂时不支持同名
export const mockList = [
  {
    url: SYS_CONFIGS_POST,
    isMock: true,
    type: "post",
    template: {
      success: true,
      content: {
        "list": [
            {
                "name": "sys.auditremind",
                "propValue": "4,9:00;5,9:00;",
                "note": "审批提醒时间"
            },
            {
                "name": "sys.notontime",
                "propValue": "7,18:00;",
                "note": "未按时提交时间"
            },
            {
                "name": "sys.reportremind",
                "propValue": "6,18:00;7,15:00;",
                "note": "周报提醒时间"
            }
        ]
    },
      message: ""
    }
  },
  {
    url: USER_LIST_POST,
    isMock: true,
    type: "post",
    template: {
      success: true,
      content: {
        "total": 3,
        "list": [{
          "id": 1,
          "name":"admin",
          "role":"admin",
        },{
          "id": 2,
          "name":"张三",
          "role":"sales",
        },{
          "id":3,
          "name":"李四",
          "role":"admin",
        }]
      },
      message: ""
    }
  },
  {
    url: REPORT_STATE_POST,
    isMock: true,
    type: "post",
    template: {
      success: true,
      content: {
        "list": [{
          "name":"姓名",
          "nosubmit": "未提交次数",
          "notontime": "未按时提交次数",
          "citycount": "拜访地市",
          "visitcount": "拜访次数",
          "visitpeople": "拜访人数",
          "hasnew": "true", //是否有拜访新客户
          "level": "运营商最高拜访级别"
        }]
      },
      message: ""
    }
  },
  {
    url: REPORT_LIST_POST,
    isMock: true,
    type: "post",
    template: {
      success: true,
      content: {
        "total": 3,
        "list": [{
          "id": 1,
          "title":"张三5月15日销售周报",
          "ctime":"2020-02-02 20:20:20",
        },{
          "id": 2,
          "title":"张三5月15日销售周报",
          "ctime":"2020-02-02 20:20:20",
        },{
          "id":3,
          "title":"张三5月15日销售周报",
          "ctime":"2020-02-02 20:20:20",
        }]
      },
      message: ""
    }
  },
  {
    url: REPORT_DETAIL_POST,
    isMock: true,
    type: "post",
    template: {
      success: true,
      content: {
        "detail":{
          "id": 1,
          "title": "张三5月15日销售周报",
          "ctime":"2020-02-02 20:20:20",
          "visit":[{
            "id": 111,
            "customer": 222,
            "city": 333,
            "duty": 444,
            "level":  11,
            "channelCustomer":  44,
            "purpose":  123,
            "result":  33,
          }],
          "summary":[{
            "idx":1,
            "content":"总结内容"
          }],
          "plan":[{
            "idx":1,
            "content":"计划内容计划"
          }]
        }
      },
      message: ""
    }
  },
];
